import type { JSX } from 'react';
import {
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';
import { resolveDefaultPlatformPath } from './platform-access';

export function PlatformWorkspaceHomePage(): JSX.Element {
  const auth = useAuth();
  const defaultPath = resolveDefaultPlatformPath(auth.platformPermissions);

  if (defaultPath) {
    return <Navigate to={defaultPath} replace />;
  }

  return (
    <Card variant="outlined" sx={{ maxWidth: 720 }}>
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="h5">Platform workspace</Typography>
          <Typography color="text.secondary">
            This account can enter the platform workspace, but no platform modules are available for
            the current permission set yet.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
